import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const TapWaterGlyph = /*#__PURE__*/createElement("g", {
  id: "tap_water"
}, /*#__PURE__*/createElement("path", {
  d: "M63.05 57.03s-6.55 12.05 0 12.05c6.47 0 0-12.05 0-12.05zM47.84 23.8c-1.91 0-9.02-1.11-9.02-4.44s7.11-4.44 9.02-4.44c3.22 0 5.74 1.95 5.74 4.44s-2.52 4.44-5.74 4.44zm-5.7-4.44c1.1.65 3.9 1.44 5.7 1.44 1.67 0 2.74-.85 2.74-1.44s-1.07-1.44-2.74-1.44c-1.8 0-4.6.8-5.7 1.44z"
}), /*#__PURE__*/createElement("path", {
  d: "M32.11 23.8c-3.22 0-5.74-1.95-5.74-4.44s2.52-4.44 5.74-4.44c1.91 0 9.02 1.11 9.02 4.44s-7.1 4.44-9.02 4.44zm0-5.88c-1.67 0-2.74.85-2.74 1.44s1.07 1.44 2.74 1.44c1.81 0 4.61-.79 5.7-1.44-1.09-.64-3.89-1.44-5.7-1.44z"
}), /*#__PURE__*/createElement("path", {
  d: "M38.48 19.36h3v9.39h-3z"
}), /*#__PURE__*/createElement("path", {
  d: "M68.22 54.71H58.07V45.9c0-.28-.22-.5-.5-.5h-6.5c-1.96 4.32-6.29 7.15-11.09 7.15s-9.13-2.83-11.09-7.15H14.33V35.25h14.61c1.98-4.26 6.29-7.06 11.04-7.06s9.06 2.8 11.04 7.06h8.7c4.69 0 8.5 3.81 8.5 8.5v10.96zm-7.15-3h4.15v-7.96c0-3.03-2.47-5.5-5.5-5.5H48.96l-.36-.99a9.206 9.206 0 00-8.63-6.07c-3.85 0-7.32 2.44-8.63 6.07l-.34.99H17.33v4.15h13.64l.35 1c1.29 3.68 4.77 6.15 8.66 6.15s7.37-2.47 8.66-6.15l.35-1h8.58c1.93 0 3.5 1.57 3.5 3.5v5.81z"
}), /*#__PURE__*/createElement("path", {
  d: "M14.33 32.09h3v16.43h-3zm42.06 19.62h13.28v3H56.39z"
}));
const TapWater = createSvg({
  name: 'tap_water',
  path: TapWaterGlyph
});

export default TapWater;
export { TapWaterGlyph };
